import { ParagraphXSmall } from "../typography/Paragraph";
import Link from "../typography/Link";
import { COLOR_PRIMARY, MOBILE_SCREEN } from "../theme";
import styled from "@emotion/styled";

const MobileBreak = styled.span`
  display: inline;
  ${MOBILE_SCREEN} {
    display: block;
  }
`;

const Footer = () => {
  return (
    <ParagraphXSmall
      marginTop="16px"
      marginBottom="16px"
      marginLeft="16px"
      marginRight="24px"
      color={COLOR_PRIMARY}
    >
      Made with &#x2764;&#xFE0F; in Boston
      <MobileBreak />
      &#xA9; Hello Prenup, Inc. {new Date().getFullYear()}. All Rights Reserved.{" "}
      <Link
        href="https://helloprenup.com/terms-of-use/?_gl=1*9e499l*_gcl_au*MTkyNDM4ODkzOS4xNzMxNDQwMjgz"
        underline={true}
        target="_blank"
        rel="noopener"
        color={COLOR_PRIMARY}
      >
        Terms
      </Link>{" "}
      &{" "}
      <Link
        href="https://helloprenup.com/privacy-policy/?_gl=1*9e499l*_gcl_au*MTkyNDM4ODkzOS4xNzMxNDQwMjgz"
        underline={true}
        target="_blank"
        rel="noopener"
        color={COLOR_PRIMARY}
      >
        Privacy
      </Link>
      .
    </ParagraphXSmall>
  );
};

export default Footer;
